/**
 * Shared entity helpers for the consumer portal.
 * Consolidates status color mappers and formatters used across entity/guarantor pages.
 */

import { BorrowingEntityStatus, GuarantorStatus } from '@ops-matrix/shared-types';

export function getEntityStatusColor(status: string): 'success' | 'warning' | 'error' | 'default' {
  switch (status) {
    case BorrowingEntityStatus.ACTIVE:
      return 'success';
    case BorrowingEntityStatus.INACTIVE:
      return 'warning';
    case BorrowingEntityStatus.DISSOLVED:
      return 'error';
    default:
      return 'default';
  }
}

export function getGuarantorStatusColor(status: string): 'success' | 'warning' | 'error' | 'info' | 'default' {
  switch (status) {
    case GuarantorStatus.ACTIVE:
      return 'success';
    case GuarantorStatus.PENDING:
      return 'warning';
    case GuarantorStatus.RELEASED:
      return 'info';
    case GuarantorStatus.DEFAULTED:
      return 'error';
    default:
      return 'default';
  }
}
